'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyGift = exports.createGift = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _sagaTools = require('@classpass/saga-tools');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  noGiftCode: {
    id: 'purchase.addGiftCode.noGiftCode',
    defaultMessage: 'Please enter your gift code to redeem.'
  }
});

var createGift = exports.createGift = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CREATE_GIFT', function (client, paymentToken, msaId, giftAmount, giftMessage, senderEmail, senderName, deliveryDate, recipientEmail, recipientName, conversion) {
  var payload = {
    gift_amount: parseFloat(giftAmount),
    payment_token: paymentToken,
    msa_id: parseInt(msaId, 10),
    delivery_date: deliveryDate,
    message: giftMessage,
    gifter: { name: senderName, email: senderEmail },
    recipient: { name: recipientName, email: recipientEmail }
  };

  if (conversion) {
    payload.conversion = conversion;
  }

  return client.gifts.create(payload);
});

var verifyGift = exports.verifyGift = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VERIFY_GIFT', function (client, userId, msaId, giftCode) {
  if (giftCode) {
    return client.gifts.getUserGifts(userId, {
      msa_id: msaId,
      redemption_code: giftCode
    }).then(function (data) {
      return data && data.gifts && data.gifts.length ? data.gifts[0] : null;
    });
  }

  // eslint-disable-next-line prefer-promise-reject-errors
  return _promise2.default.reject({ message: messages.noGiftCode });
});